<template>
  <f7-page >
    <f7-list id="nav-steps">
      <f7-list-item title="initial" data-step=-1   v-on:click="setStep"></f7-list-item>
      <f7-list-item
        v-for="step in steps"
        :key="step.step"
        :title="step.lib"
        :data-step="step.step"
        v-on:click="setStep"

       ></f7-list-item>

    </f7-list>
  </f7-page>
</template>
<script>

/*var stepsList =  [
  ["CH"],
  ["Pangle_P29"],
  ["Pangle_P10"],
  ["Pangle_P1"],
  ["Pangle_P21"],
  ["CD-TE-C_C-RE-CD-M7-PO-BA-#-RA-RE-CD-M7-PO-BA-#-CD-M7-PO-BA"],
  ["T6"]
];
*/
import stepsList from "../js/visioneuse/steps.json";
import { serverBus } from '../main';

export default {
  data:function(){

    let steps = [];
    for (let i = 0; i < stepsList.length; i++) {
      steps.push({
          "lib": "Etapes " + (i + 1),
          "step": i,
        })
    }
    return {
     'steps':steps
    }
  },
  methods:{
    setStep:function(e){
      var step = this.$$(e.target).closest('li').data('step');
      serverBus.$emit('stepChange', step);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partial/panel-left.vue